module.exports = __webpack_public_path__ + "img/c71d714482b9f40a30539aa0ddb4bc40.png";